import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Geo from 'drip/geo';
import { LazyImage } from '@/components/common';
export default {
  props: {
    videoList: {
      type: Array,
      value: []
    },
    celebrityId: {
      type: Number,
      value: 0
    }
  },
  data: function data() {
    return {
      videoPlayerId: 0
    };
  },
  components: {},
  mounted: function mounted() {},
  methods: {
    onplay: function onplay(e, video) {
      var id = +this.$refs['videoPlayer' + video.id][0].dataset['id'];
      if (this.videoPlayerId !== 0 && id !== this.videoPlayerId) {
        var formerPlayer = this.$refs['videoPlayer' + this.videoPlayerId][0];
        formerPlayer.pause();
      }
      this.videoPlayerId = video.id;
      this.bidVideo();
    },
    to: function to(e) {
      try {
        var target = e.currentTarget;
        var performanceId = target.dataset.performanceid;
        this.go("/detail/".concat(performanceId), {
          _blank: true
        });
      } catch (e) {
        console.log('clickStatus error', e);
      }
    },
    bidVideo: function bidVideo() {
      if (this.videoPlayerId) {
        var cityId = Drip.constant.cityId;
        var gcityId = (Geo.getLocCitySync() || {}).cityId || cityId;
        window.seedAction({
          evt: 'click',
          bid: 'b_movie_1eukrw78_mc',
          custom: {
            celebrity_id: this.celebrityId,
            content_id: this.videoPlayerId,
            city_id: cityId,
            gcity_id: gcityId
          }
        });
      }
    }
  }
};